import Layout from '@scripts/routes/Layout';

/**
 * Creates a new *Page*.
 *
 * *Page* is the default *Renderer*.
 *
 * Every other renderer should extend *Page* and implements its useful methods.
 *
 * @class
 * @augments Renderer
 */
export default class Page extends Layout {

  onEnter() {
    super.onEnter()
  }

  onEnterCompleted() {
    super.onEnterCompleted()
  }

}
